import Calc from "@/common/util/calculator"
import BaseScrewFixmethod from "@/signomatic/app/fixmethods/base_screw"

export default class ScrewSolidPlasticFixmethod extends BaseScrewFixmethod {
  positions() {
    const { shape, border, width, widthPx, height, heightPx } = this.state
    const diameter = Calc.mmToPx(4)
    const cappedScrew = this.state.fixmethod === "screw_capped"
    let headDiameter = Calc.mmToPx(7)
    const positions = []
    const centerV = heightPx / 2 - diameter / 2
    let distance = 0
    const hasBorder = border !== "none"

    if (cappedScrew) {
      headDiameter = width > 399 || height > 399 ? Calc.mmToPx(15) : Calc.mmToPx(10)
    }

    const defaults = { diameter, headDiameter }

    if (["rect", "round"].includes(shape)) {
      const fourScrews = height >= 100
      const sixScrews = (height > 499 && width > 999) || (width > 499 && height > 999)
      const shortest = width > height ? "height" : "width"

      if (shape === "rect") {
        if (sixScrews || (fourScrews && (width > 500 || height > 500))) {
          distance = Calc.mmToPx(12)
        } else if (fourScrews) {
          switch (border) {
            case "none":
              distance = this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(12), {
                maxWidth: 500,
                maxHeight: 500,
              })
              break
            case "thin":
              if (cappedScrew) {
                distance = this.drawables.sizeRelative(shortest, Calc.mmToPx(11), Calc.mmToPx(29), {
                  maxWidth: 500,
                  maxHeight: 500,
                })
              } else {
                distance = this.drawables.sizeRelative(shortest, Calc.mmToPx(8.5), Calc.mmToPx(25), {
                  maxWidth: 500,
                  maxHeight: 500,
                })
              }
              break
            case "rounded":
              distance = this.drawables.sizeRelative(shortest, Calc.mmToPx(11), Calc.mmToPx(cappedScrew ? 40 : 37), {
                maxWidth: 500,
                maxHeight: 500,
              })
              break
            case "retro":
              distance = this.drawables.sizeRelative("longest", Calc.mmToPx(6), Calc.mmToPx(12), {
                maxWidth: 500,
                maxHeight: 500,
              })
              break
          }
        } else {
          if (cappedScrew) {
            distance = this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(hasBorder ? 14 : 12))
          } else {
            distance = this.drawables.sizeRelative("width", Calc.mmToPx(hasBorder ? 7 : 5), Calc.mmToPx(12))
          }
        }
      } else if (shape === "round") {
        if (sixScrews || fourScrews) {
          if (hasBorder) {
            if (width <= 500 && height <= 500) {
              distance = this.drawables.sizeRelative(shortest, Calc.mmToPx(11), Calc.mmToPx(37), {
                minWidth: 100,
                minHeight: 100,
                maxWidth: 500,
                maxHeight: 500,
              })
            } else {
              distance = this.drawables.sizeRelative("height", Calc.mmToPx(37), Calc.mmToPx(80), {
                minWidth: 500,
                minHeight: 500,
              })
            }
          } else {
            if (width <= 500 && height <= 500) {
              distance = this.drawables.sizeRelative(shortest, Calc.mmToPx(11), Calc.mmToPx(37), {
                minWidth: 100,
                minHeight: 100,
                maxWidth: 500,
                maxHeight: 500,
              })
            } else {
              distance = this.drawables.sizeRelative(shortest, Calc.mmToPx(37), Calc.mmToPx(cappedScrew ? 56 : 44), {
                minWidth: 500,
                minHeight: 500,
              })
            }
          }
        } else {
          // two screws
          if (cappedScrew) {
            distance = this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(hasBorder ? 14 : 12))
          } else {
            distance = this.drawables.sizeRelative("width", Calc.mmToPx(hasBorder ? 7 : 5), Calc.mmToPx(12))
          }
        }
      }

      const left = distance - diameter / 2
      const top = distance - diameter / 2
      const bottom = heightPx - distance - diameter / 2
      const right = widthPx - distance - diameter / 2
      const centerH = widthPx / 2 - diameter / 2

      if (sixScrews) {
        positions.push({ ...defaults, left: centerH, top })
        positions.push({ ...defaults, left: centerH, top: bottom })
      }

      if (fourScrews || sixScrews) {
        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
      } else {
        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
      }
    } else if (shape === "rotated_rect") {
      const fourScrews = height >= 500 || width >= 500

      if (fourScrews) {
        if (hasBorder) {
          distance = this.drawables.sizeRelative("width", Calc.mmToPx(34), Calc.mmToPx(86), {
            minWidth: 500,
            minHeight: 500,
          })
        } else {
          distance = this.drawables.sizeRelative("width", Calc.mmToPx(14), Calc.mmToPx(30), {
            minWidth: 500,
            minHeight: 500,
          })
        }
      } else {
        distance = this.drawables.sizeRelative("width", Calc.mmToPx(9), Calc.mmToPx(hasBorder ? 34 : 14), {
          minWidth: 70,
          minHeight: 70,
          maxWidth: 499,
          maxHeight: 499,
        })
      }

      const center = widthPx / 2 - diameter / 2
      const top = distance - diameter / 2
      const bottom = heightPx - diameter / 2 - distance
      const left = distance - diameter / 2
      const right = widthPx - diameter / 2 - distance

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })

      if (fourScrews) {
        positions.push({ ...defaults, left: center, top: top })
        positions.push({ ...defaults, left: center, top: bottom })
      }
    } else if (["ellipse", "stop"].includes(shape)) {
      const center = widthPx / 2 - diameter / 2

      if (width >= 500) {
        const minTop = Calc.mmToPx(11)
        const maxTop = Calc.mmToPx(25)

        distance = this.drawables.sizeRelative("width", minTop, maxTop, { minWidth: 500 })

        const left = distance - diameter / 2
        const right = widthPx - diameter / 2 - distance
        const top = distance - diameter / 2
        const bottom = heightPx - diameter / 2 - distance

        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
        positions.push({ ...defaults, left: center, top })
        positions.push({ ...defaults, left: center, top: bottom })
      } else {
        const minTop = cappedScrew ? Calc.mmToPx(hasBorder ? 8 : 6) : Calc.mmToPx(hasBorder ? 7 : 5)
        const maxTop = cappedScrew ? Calc.mmToPx(hasBorder ? 26 : 14) : Calc.mmToPx(11)

        distance = this.drawables.sizeRelative("height", minTop, maxTop)

        const left = distance - diameter / 2
        const right = widthPx - diameter / 2 - distance

        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
      }
    } else if (["direction_left", "direction_right"].includes(shape)) {
      let distanceFront = this.drawables.sizeRelative(
        "width",
        Calc.mmToPx(hasBorder ? 10 : 9),
        Calc.mmToPx(hasBorder ? 36 : 25),
        { minWidth: 70, maxWidth: 600 }
      )
      let distanceBack = this.drawables.sizeRelative(
        "width",
        Calc.mmToPx(hasBorder ? 6 : 5),
        Calc.mmToPx(hasBorder ? 26 : 11),
        { minWidth: 70, maxWidth: 600 }
      )

      if (cappedScrew) {
        distanceFront = this.drawables.sizeRelative(
          "width",
          Calc.mmToPx(hasBorder ? 12 : 11),
          Calc.mmToPx(hasBorder ? 40 : 30),
          { minWidth: 70, maxWidth: 600 }
        )
        distanceBack = this.drawables.sizeRelative(
          "width",
          Calc.mmToPx(hasBorder ? 7 : 6),
          Calc.mmToPx(hasBorder ? 28 : 11),
          { minWidth: 70, maxWidth: 600 }
        )
      }

      let left = distanceFront - diameter / 2
      let right = widthPx - diameter / 2 - distanceBack

      if (shape === "direction_right") {
        left = distanceBack - diameter / 2
        right = widthPx - diameter / 2 - distanceFront

        positions.push({
          ...defaults,
          left: widthPx - diameter / 2 - distanceBack,
          top: centerV,
          stretch: true,
        })
      } else {
        positions.push({
          ...defaults,
          left: distanceBack - diameter / 2,
          top: centerV,
          stretch: true,
        })
      }

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
    } else if (shape === "triangle") {
      const min = cappedScrew ? Calc.mmToPx(7) : Calc.mmToPx(5)
      const max = Calc.mmToPx(hasBorder ? 52 : 18)
      distance = this.drawables.sizeRelative("height", min, max)

      const offset = Calc.triangleHorizontalOffset(widthPx, heightPx, distance) + 10
      const minTop = cappedScrew ? Calc.mmToPx(hasBorder ? 16 : 14) : Calc.mmToPx(hasBorder ? 15 : 12)
      const maxTop = Calc.mmToPx(hasBorder ? 95 : 30)
      const distanceTop = this.drawables.sizeRelative("height", minTop, maxTop)

      const center = widthPx / 2 - diameter / 2
      const top = distanceTop - diameter / 2
      const topStretch = distance - headDiameter / 2
      const bottom = heightPx - diameter / 2 - distance
      const left = offset + distance - diameter / 2
      const right = widthPx - offset - diameter / 2 - distance

      positions.push({ ...defaults, left: center, top })
      positions.push({ ...defaults, left, top: bottom })
      positions.push({ ...defaults, left: right, top: bottom })
      positions.push({ ...defaults, left: center, top: topStretch, stretch: true })
    }

    return positions
  }
}
